import { FunctionComponent } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import classnames from 'classnames'

import transferCss from './styles.module.scss'

const SKELETON_BAR_HEIGHTS = [
  42, 68, 36, 54, 78, 40, 62, 48, 72, 34, 58, 44, 70, 52, 38, 64,
]

type TransfersSkeletonProps = {
  showConvenioTabs?: boolean
}

const TransfersSkeleton: FunctionComponent<TransfersSkeletonProps> = ({
  showConvenioTabs = false,
}) => (
  <div className={transferCss.skeletonLayout} aria-hidden="true">
    {showConvenioTabs && (
      <div className={transferCss.skeletonConvenioTabs}>
        <div className={transferCss.skeletonBlock} />
        <div className={transferCss.skeletonBlock} />
        <div className={transferCss.skeletonBlock} />
      </div>
    )}

    <Row>
      {Array.from({ length: 5 }).map((_, index) => (
        <Col
          key={index}
          className={classnames(transferCss.cardCol, {
            [transferCss.cardPendingPadding]: index === 0,
            [transferCss.cardGlossedAndReleasedPadding]:
              index === 1 || index === 3,
            [transferCss.cardProcessingPadding]: index === 2,
            [transferCss.cardPaidPadding]: index === 4,
            [transferCss.paidCardCol]: index === 4,
          })}
        >
          <Card className={classnames('mb-2', transferCss.skeletonCard)}>
            <Card.Body className={transferCss.skeletonCardBody}>
              <div
                className={classnames(
                  transferCss.skeletonBlock,
                  transferCss.skeletonTitle
                )}
              />
              <div
                className={classnames(
                  transferCss.skeletonBlock,
                  transferCss.skeletonValue
                )}
              />
              {index < 3 && (
                <div
                  className={classnames(
                    transferCss.skeletonBlock,
                    transferCss.skeletonDescription
                  )}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>

    <div className={transferCss.mainContentArea}>
      <Row className={transferCss.chartRow}>
        <Col className={transferCss.chartCol}>
          <Card className={transferCss.skeletonChartCard}>
            <div className={transferCss.skeletonChartHeader}>
              <div
                className={classnames(
                  transferCss.skeletonBlock,
                  transferCss.skeletonChartTitle
                )}
              />
              <div
                className={classnames(
                  transferCss.skeletonBlock,
                  transferCss.skeletonChartActions
                )}
              />
            </div>
            <div className={transferCss.skeletonChartArea}>
              <div className={transferCss.skeletonChartPlot}>
                <div className={transferCss.skeletonChartXAxis} />
                <div className={transferCss.skeletonChartBars}>
                  {SKELETON_BAR_HEIGHTS.map((height, index) => (
                    <div
                      key={index}
                      className={transferCss.skeletonChartBar}
                      style={{ height: `${height}%` }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row className={transferCss.footerSection}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Col
            key={index}
            className={classnames(transferCss.footerCardCol, {
              [transferCss.cardAtendPadding]: index === 0,
              [transferCss.cardPmrPadding]: index === 1,
              [transferCss.cardTicketPadding]: index === 2,
            })}
          >
            <Card className={transferCss.skeletonFooterCard}>
              <Card.Body className={transferCss.skeletonFooterBody}>
                <div
                  className={classnames(
                    transferCss.skeletonBlock,
                    transferCss.skeletonFooterTitle
                  )}
                />
                <div
                  className={classnames(
                    transferCss.skeletonBlock,
                    transferCss.skeletonFooterSubtitle
                  )}
                />
                <div
                  className={classnames(
                    transferCss.skeletonBlock,
                    transferCss.skeletonFooterValue
                  )}
                />
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  </div>
)

export default TransfersSkeleton
